const de = {
    actionAlready: "Noch nicht registriert? Anmelden",
    actionExit: "Abmelden",
    actionLogin: "ANMELDEN",
    actionRegister: "REGISTRIEREN",
    actionSave: "SPEICHERN",
    actionStart: "STARTEN",
    actionContinue: "WEITER",
    actionReset: "BEWERTUNG ZURÜCKSETZEN",
    actionDoDiagnost: "DIAGNOSE ANZEIGEN",
    actionYes: "Ja",
    actionNo: "Nein",
    actionNext: "WEITER",
    actionBusinessCase: "GUTE PRAXIS DES UNTERNEHMENS ANZEIGEN",
    actionBusinessCases: "GUTE PRAXIS VON UNTERNEHMEN ANZEIGEN",
    actionOpenUrl: "URL ÖFFNEN",
    actionFilter: "FILTER",

    /** HOME */
    msgHomeTitleOne: "Messen und steigern Sie das zirkuläre Reifegradniveau Ihres Möbelunternehmens",
    msgHomeSubTitle: "Das FurnCIRCLE-Online-Tool bewertet den Fortschritt Ihres Unternehmens hin zur zirkulären Reife anhand der eingesetzten zirkulären Designstrategien",

    msgHomeSection2: "Bewerten und verbessern Sie die Reife Ihrer Möbelunternehmen in der Kreislaufwirtschaft",
    msgHomeSection2Text: "<span style='font-weight:bold;'>FurnCIRCLE Circular Economy Assessment Tool</span><br/><br/>FurnCIRCLE ist ein Online-Selbstbewertungstool, das Möbelherstellern hilft, ihre Reife in der Kreislaufwirtschaft zu bewerten und Verbesserungspotenziale zu identifizieren.<br/><br/><span style='font-weight:bold;'>Sind Sie bereit, Ihre zirkuläre Reife zu bewerten?</span><ul style='padding-left: 20px'><li>Beantworten Sie Fragen zu den in Ihrem Unternehmen umgesetzten zirkulären Designstrategien.</li><li>Entdecken Sie Ihr Reifegradniveau in der Kreislaufwirtschaft.</li><li>Identifizieren Sie Strategien und Best Practices, um Ihr Unternehmen auf die nächste Stufe zu bringen.</li><li>Lernen Sie aus realen Branchenbeispielen und verbessern Sie Ihre zirkuläre Leistung kontinuierlich.</li></ul>",
    msgHomeSection21Text: "<span style='font-weight:bold;'>Tragen Sie zur europäischen Bewertung der Zirkularität in der Möbelbranche bei | R-evolve-Projekt</span><br/><br/>FurnCIRCLE wird derzeit im <a href='https://r-evolve.eu/' target='_blank' rel='noopener noreferrer'>R-evolve-Projekt</a> eingesetzt, um die Reife der Kreislaufwirtschaft im europäischen Möbelsektor zu bewerten. <span style='font-weight:bold;'>Mehr als 400 Unternehmen in ganz Europa</span> sind eingeladen, teilzunehmen und dabei zu helfen, das aktuelle Zirkularitätsniveau der Branche zu erfassen.<br/><br/>Nehmen Sie an der Bewertung teil, bewerten Sie Ihr Unternehmen und tragen Sie dazu bei, die Zukunft des Sektors mitzugestalten.<br/><br/>Alle Daten werden vertraulich behandelt und ausschließlich in aggregierter Form für Benchmarking- und Forschungszwecke verwendet. <span style='font-weight:bold;'>Teilnehmende erhalten Zugang zu aggregierten Benchmarking-Ergebnissen</span>, wodurch sie ihre Leistung mit Branchendurchschnitten auf Grundlage anonymisierter und aggregierter Daten von teilnehmenden Unternehmen des europäischen Möbelsektors vergleichen können.<br/><br/>Die Bewertung dauert etwa 30 bis 45 Minuten.",
    msgHomeSection3: "Partner",
    msgHomeSection2Btn: "Starten Sie Ihre Bewertung",
    msgHomeSection3Btn: "KONTAKT",

    /** HEADER */
    msgHeader1: "Zirkuläre Designstrategien und bewährte Praktiken",
    msgHeader4: "Anmelden",

    /** DRAWER */
    msgCompany: "UNTERNEHMEN",
    msgDrawer1: "1. Beantworten",
    msgDrawer2: "2. Bewerten",
    msgDrawer3: "3. Verbessern",
    msgDrawer4: "Sammlung von Strategien",
    msgDrawer6: "Einstellungen",
    msgDrawer7: "Abmelden",

    /** LOGIN */
    msgWelcome: "Willkommen",
    msgWelcomeSubtitle: "Bitte melden Sie sich an, um fortzufahren",

    /** REGISTER */
    msgGetStarted: "Loslegen",
    msgGetStartedSubtitle: "Dieses Selbsteinschätzungstool ist kostenlos und vertraulich",

    msgFirstname: "Vorname",
    msgLastname: "Nachname",
    msgEmail: "E-Mail",
    msgPassword: "Passwort",
    msgConfirmPassword: "Passwort bestätigen",
    msgCompanyUser: "Unternehmen oder Benutzername",

    msgLegalRegister: "Ich habe die <a href='https://ambitcluster.org/en/privacy-policy'>Datenschutzrichtlinie</a> gelesen und stimme ihr zu.",
    errorLegalRegister: "Sie müssen die Datenschutzrichtlinie lesen und akzeptieren, um fortzufahren",
    msgLegalRegisterText: "Hinweis: Personenbezogene Daten werden von AMBIT über das FurnCIRCLE-Tool ausschließlich für technische und operative Zwecke erhoben. Die Umfrageantworten werden im Rahmen des R-evolve-Projekts analysiert. Es werden keine personenbezogenen Daten oder unternehmensidentifizierenden Informationen an die Partner des R-evolve-Konsortiums weitergegeben. Alle Antworten werden auf streng anonymer Basis analysiert. Für statistische Zwecke können Daten nach Land oder Tätigkeitsbereich aggregiert werden. Die vom Tool generierten Ergebnisse werden unter keinen Umständen mit einem einzelnen Unternehmen verknüpft oder zur Identifizierung verwendet.",

    msgNotRegister: "Noch nicht registriert? <b>Erstellen Sie hier ein Konto</b>",
    msgAlreadyRegister: "Bereits registriert? <b>Hier anmelden</b>",

    /** HOME TOOL */
    msgClickImage: "Klicken Sie, um das lineare vs. zirkuläre Modellsystem zu erweitern.",

    msgArea: "BEREICH",
    msgProgress: "BEANTWORTETE FRAGEN",

    msgAssessmentAreas: "Zirkuläre Designstrategien und Produktlebenszyklus",
    msgAssessmentDesc: "Kreislauforientierte Designstrategien werden vor allem in der Design- und Entwicklungsphase von Produkten angewendet. Ihr (positiver) Einfluss entfaltet sich jedoch in einer oder mehreren späteren Phasen des Produktlebenszyklus und wird durch After-Sales-Services unterstützt. Eine Möglichkeit zur Einordnung kreislauforientierter Designstrategien besteht daher darin, sie nach der betroffenen Lebenszyklusphase zu klassifizieren: Design, materielle Ressourcen, Produktion, Distribution, Nutzungsphase und End-of-Life.<br/><br/>Für die Entfaltung von Zirkularitätsstrategien ist der allgemeine Ansatz eines Unternehmens hin zur zukünftigen Kreislaufwirtschaft von zentraler Bedeutung, ebenso die in Art. 5(1) der europäischen Ökodesign-Verordnung für nachhaltige Produkte (ESPR) festgelegten 'Produktaspekte' sowie der durch die ESPR eingeführte Digitale Produktpass (DPP).<br/><br/>Die ESPR ist eine tragende Säule der EU-Strategie für eine ressourceneffiziente, schadstoffarme und klimafreundliche Kreislaufwirtschaft (CE). Sie schafft einen Rahmen für verbindliche Marktzugangsbedingungen für Produkte und verlangt ambitionierte Umwelt- und Ressourceneffizienzziele, um innerhalb planetarer Grenzen zu bleiben. Gemäß den in Art. 5(1) definierten 'Produktaspekten' müssen Produkte auf lange Nutzungsdauer, einfache Reparierbarkeit, Wiederverwendung und Refurbishment sowie sicheres Recycling (auch als R-Strategien bekannt) ausgelegt sein. Zudem müssen sie frei von problematischen Stoffen und für eine hochwertige Materialrückgewinnung geeignet sein.<br/><br/>Der DPP, wie in der ESPR vorgesehen, soll die entsprechende harmonisierte Infrastruktur für Produktdaten bereitstellen, die Transparenz, Rückverfolgbarkeit und nachhaltige Geschäftsinnovationen ermöglicht.<br/><br/>Details finden Sie im R-evolve Factsheet | <a href='https://r-evolve.eu/' target='_blank' rel='noopener noreferrer'>https://r-evolve.eu/</a><br/><br/><span style='font-weight:bold;'>Bitte beantworten Sie alle Fragen für jeden Block bzw. jede Lebenszyklusphase, bestimmen Sie Ihr Niveau der Kreislaufreife und planen Sie Ihre Verbesserung sowie den Übergang zu einer stärker kreislauforientierten Wirtschaft.</span>",

    msgAssessment: "FurnCIRCLE Bewertung",
    msgNotApply: "Markieren Sie alle Antworten, die auf die aktuelle zirkuläre Leistung Ihres Unternehmens zutreffen. Die Antworten werden automatisch gespeichert.",
    msgMarkImportant: "Als wichtig markieren",
    msgComment: "Kommentar",
    msgCommentHolder: "Hier können Sie relevante Informationen oder eigene Kommentare schreiben.",

    /** ANSWER */
    msgPerformance: "Bewertungsbericht",
    msgPerformanceSubtitle: "Überprüfen Sie den zirkulären Reifegradindex Ihres Unternehmens und jeder Phase des Produktlebenszyklus.",
    msgCompanyLevel: "Zirkulärer Reifegradindex Ihres Unternehmens (0%-100%)",
    msgBlockArea: "LEBENSZYKLUSPHASE",
    msgBlockValues: "WERTE",

    /** ASSESS */
    msgImprovement: "Verbesserungsbericht",
    msgImprovementMainSubtitle: "Erfahren Sie, was Sie tun können, um die Zirkularität Ihres Unternehmens kontinuierlich zu verbessern. Lernen Sie Designstrategien und bewährte Praktiken anderer Unternehmen kennen, um Ihr Unternehmen auf das nächste Level zu bringen.</br></br>Lebenszyklusphasen und zirkuläre Designstrategien mit einem „roten“ Label/Kreis haben eine Leistung von maximal 25 % ihres Höchstwertes und sollten daher als oberste Priorität für die Verbesserung der Zirkularität des Unternehmens betrachtet werden. Phasen oder Strategien mit einem „orangen“ Label/Kreis haben eine Leistung zwischen 25 % und 75 % und sollten daher ebenfalls verbessert werden. Phasen oder Strategien mit einem „grünen“ Label/Kreis haben eine Leistung von über 75 % und haben daher eine geringere Priorität für Verbesserungen.",
    msgImprovementSubtitle: "Erfahren Sie, was Sie tun können, um die Zirkularität Ihres Unternehmens kontinuierlich zu verbessern. Lernen Sie Designstrategien und bewährte Praktiken anderer Unternehmen kennen, um Ihr Unternehmen auf das nächste Level zu bringen.",
    msgLifecyclePhases: "Lebenszyklusphasen",
    msgLifecycleIndex: "Phasenzirkularitätsindex",
    msgActionsToImplement: "Umzusetzende Maßnahmen:",
    msgBaselineScore: "Meine Ausgangsbewertung",
    msgBusinessCaseEmpty: "Glückwunsch! Sie haben bereits die wichtigsten Strategien dieser Kategorie implementiert.",

    msgCat1: "WIRTSCHAFTLICH UND ORGANISATORISCH",
    msgCat2: "GESELLSCHAFTLICH",
    msgCat3: "UMWELTBEZOGEN",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Durchsuchen und erkunden Sie die vollständige Sammlung zirkulärer Designstrategien und bewährter Praktiken des FurnCIRCLE-Projekts.",
    msgLifecyclePhase: "Lebenszyklusphase",
    msgDifficulty: "Schwierigkeit der Implementierung",
    msgBusinessDynamics: "Wertschöpfung oder -bereitstellung",
    msgBusinessFactors: "Wertangebot / Kosten / Nutzen",

    /** SETTINGS */
    msgUserInfo: "Benutzerinformationen",
    msgUserCredentials: "Benutzeranmeldedaten",

    /** MODAL */
    msgAreSure: "Sind Sie sicher?",

    msgSuccess: "Daten erfolgreich aktualisiert",
    msgDeleteSuccess: "Daten erfolgreich gelöscht",

    /** ALT TEXT */
    msgSaveCommentAlt: "Speichern Sie den “Kommentar”. Es ist nicht notwendig, die Antworten auf die Fragen zu speichern; sie werden automatisch gespeichert.",
    msgDifficultyAlt: "Dieses Label zeigt den Schwierigkeitsgrad der Umsetzung der zirkulären Designstrategie an.",
    msgBusinessBlockAlt: "Dieses Label zeigt an, welcher Geschäftsblock des CANVAS-Modells (Wertschöpfung oder Wertlieferung) von der Umsetzung der zirkulären Designstrategie betroffen ist.",
    msgImpactBlockAlt: "Dieses Label zeigt an, welcher Wirkungsblock des CANVAS-Modells (Kosten, Nutzen oder Wertversprechen) von der Umsetzung der zirkulären Designstrategie betroffen ist.",

    /** ERROR */
    errorOblData: "Füllen Sie alle Pflichtfelder aus",
    errorEmailFormat: "Fehler im E-Mail-Format",
    errorUserIncorrect: "E-Mail/Passwort falsch",
    errorSend: "Kommunikationsfehler, bitte warten Sie und versuchen Sie es später erneut",
    errorLength: "Die Anzahl der Zeichen wurde überschritten",
    errorPassSame: "Passwörter stimmen nicht überein",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Passwort-Wiederherstellung",
    msgRecoveryPasswordSubtitle: "Bitte geben Sie Ihre E-Mail-Adresse ein, um einen Code zum Zurücksetzen des Passworts zu erhalten.",
    msgCode: "Code",
    msgNewPassword: "Neues Passwort",
    actionRequestCode: "CODE ANFORDERN",
    actionUpdate: "AKTUALISIEREN",
    actionBack: "ZURÜCK",
    msgForgetPassword: "Passwort vergessen?",
    errorRecovery: "Fehler bei der Passwort-Wiederherstellung, bitte überprüfen Sie den angegebenen Code",

    /** FOOTER */
    msgFooterContact: "KONTAKT",

    msgFooterGr: "Von der Europäischen Union finanziert. Die geäußerten Ansichten und Meinungen sind jedoch ausschließlich die des Autors/der Autoren und spiegeln nicht notwendigerweise die der Europäischen Union wider. Weder die Europäische Union noch die Förderbehörde können für sie verantwortlich gemacht werden. Ausschreibung und Fördervereinbarungsreferenz: SOCPL-2022-SOC-DIALOG-01 (Projekt 101102389)",
    msgCopyright: "Copyright&copy;2025 AMBIT. Alle Rechte vorbehalten",

    msgFooterLegal: "Rechtlicher Hinweis",
    msgFooterPrivacy: "Datenschutz",
    msgFooterCookies: "Cookie-Richtlinie",

    /** PROGRESS VALUES */
    msgProgress0: "Zirkuläre Designstrategien",

    /** COMPANY SIZES */
    msgCompanySize: "Größe des Unternehmens",
    msgCompanySize1: "Weniger als 10 Mitarbeiter",
    msgCompanySize2: "10-30 Mitarbeiter",
    msgCompanySize3: "30-50 Mitarbeiter",
    msgCompanySize4: "Mehr als 50 Mitarbeiter",

    /** PRODUCT TYPES */
    msgProductType: "Art der hergestellten Produkte",
    msgProductType1: "Schlafzimmermöbel und Betten",
    msgProductType2: "Kinder-/Jugendzimmer",
    msgProductType3: "Schlafsysteme: Matratzen und Untergestelle",
    msgProductType4: "Wohnbereichsmöbel",
    msgProductType5: "Stühle",
    msgProductType6: "Küchenmöbel",
    msgProductType7: "Polstermöbel",
    msgProductType8: "Outdoormöbel",
    msgProductType9: "Flat-Pack-/DIY-Möbel",
    msgProductType10: "Möbel für Gesundheits- und Pflegeeinrichtungen (Krankenhäuser, Pflegeheime usw.)",
    msgProductType11: "Möbel für öffentliche Räume (Flughäfen, Kirchen, Theater und Kinos) ohne Sitzmöbel",
    msgProductType12: "Maßgefertigte Wohnmöbel",
    msgProductType13: "Accessoires - Ergänzungselemente",
    msgProductType14: "Accessoires - Dekorationsobjekte",
    msgProductType15: "Accessoires - Textilien",
    msgProductType16: "Objekteinrichtungen (Einzelhandel / Contract Interiors)",
    msgProductType17: "Halbfertige Komponenten für Möbel",
    msgProductType18: "Sonstige Möbel",
    msgProductType19: "Badmöbel (einschließlich Arbeitsplatten)",
    msgProductType20: "Büromöbel",
    msgProductType21: "Bürotrennwände / Wände",
    msgProductType22: "Bürositzmöbel",
    msgProductType23: "Öffentliche Sitzmöbel / Sitzmöbel für Gemeinschaftsbereiche",
    msgProductType24: "Akustikpaneele / akustische Möbel",
    msgProductType25: "Komponenten für Büromöbel",
    msgProductType26: "Sonstige Büromöbel / Ausstattung",
    msgProductType27: "Bildungsmöbel",

    /* COUNTRIES */
    msgCountry: "Land",
    msgAfghanistan: "Afghanistan",
    msgAlbania: "Albanien",
    msgAlgeria: "Algerien",
    msgAmericanSamoa: "Amerikanisch-Samoa",
    msgAndorra: "Andorra",
    msgAngola: "Angola",
    msgAnguilla: "Anguilla",
    msgAntarctica: "Antarktis",
    msgAntiguaandBarbuda: "Antigua und Barbuda",
    msgArgentina: "Argentinien",
    msgArmenia: "Armenien",
    msgAruba: "Aruba",
    msgAustralia: "Australien",
    msgAustria: "Österreich",
    msgAzerbaijan: "Aserbaidschan",
    msgBahamas: "Bahamas",
    msgBahrain: "Bahrain",
    msgBangladesh: "Bangladesch",
    msgBarbados: "Barbados",
    msgBelarus: "Weißrussland",
    msgBelgium: "Belgien",
    msgBelize: "Belize",
    msgBenin: "Benin",
    msgBermuda: "Bermuda",
    msgBhutan: "Bhutan",
    msgBolivia: "Bolivien",
    msgBosniaHerzegovina: "Bosnien und Herzegowina",
    msgBotswana: "Botswana",
    msgBouvetIsland: "Bouvetinsel",
    msgBrazil: "Brasilien",
    msgBritishIndian: "Britisches Territorium im Indischen Ozean",
    msgBrunei: "Brunei",
    msgBulgaria: "Bulgarien",
    msgBurkinaFaso: "Burkina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Kambodscha",
    msgCameroon: "Kamerun",
    msgCanada: "Kanada",
    msgCapeVerde: "Kap Verde",
    msgCaymanIslands: "Kaimaninseln",
    msgCentralAfrican: "Zentralafrikanische Republik",
    msgChad: "Tschad",
    msgChile: "Chile",
    msgChina: "China",
    msgChristmasIsland: "Weihnachtsinsel",
    msgCocosIslands: "Kokosinseln",
    msgColombia: "Kolumbien",
    msgComoros: "Komoren",
    msgCongo: "Kongo",
    msgRepublicCongo: "Demokratische Republik Kongo",
    msgCookIslands: "Cookinseln",
    msgCostaRica: "Costa Rica",
    msgIvoryCoast: "Elfenbeinküste",
    msgCroatia: "Kroatien",
    msgCuba: "Kuba",
    msgCyprus: "Zypern",
    msgCzechRepublic: "Tschechische Republik",
    msgDenmark: "Dänemark",
    msgDjibouti: "Dschibuti",
    msgDominica: "Dominica",
    msgDominicanRepublic: "Dominikanische Republik",
    msgEastTimor: "Osttimor",
    msgEcuador: "Ecuador",
    msgEgypt: "Ägypten",
    msgEngland: "England",
    msgElSalvador: "El Salvador",
    msgEquatorialGuinea: "Äquatorialguinea",
    msgEritrea: "Eritrea",
    msgEstonia: "Estland",
    msgEthiopia: "Äthiopien",
    msgFalklandIslands: "Falklandinseln",
    msgFaroeIslands: "Färöer-Inseln",
    msgFijiIslands: "Fidschi-Inseln",
    msgFinland: "Finnland",
    msgFrance: "Frankreich",
    msgFrenchGuiana: "Französisch-Guayana",
    msgFrenchPolynesia: "Französisch-Polynesien",
    msgFrenchSouthern: "Französische Süd- und Antarktisgebiete",
    msgGabon: "Gabun",
    msgGambia: "Gambia",
    msgGeorgia: "Georgien",
    msgGermany: "Deutschland",
    msgGhana: "Ghana",
    msgGibraltar: "Gibraltar",
    msgGreece: "Griechenland",
    msgGreenland: "Grönland",
    msgGrenada: "Grenada",
    msgGuadeloupe: "Guadeloupe",
    msgGuam: "Guam",
    msgGuatemala: "Guatemala",
    msgGuernsey: "Guernsey",
    msgGuinea: "Guinea",
    msgGuineaBissau: "Guinea-Bissau",
    msgGuyana: "Guyana",
    msgHaiti: "Haiti",
    msgHeardMcDonald: "Heard und McDonaldinseln",
    msgHolySee: "Heiliger Stuhl (Vatikanstadt)",
    msgHonduras: "Honduras",
    msgHongKong: "Hongkong",
    msgHungary: "Ungarn",
    msgIceland: "Island",
    msgIndia: "Indien",
    msgIndonesia: "Indonesien",
    msgIran: "Iran",
    msgIraq: "Irak",
    msgIreland: "Irland",
    msgIsrael: "Israel",
    msgIsleMan: "Isle of Man",
    msgItaly: "Italien",
    msgJamaica: "Jamaika",
    msgJapan: "Japan",
    msgJersey: "Jersey",
    msgJordan: "Jordanien",
    msgKazakhstan: "Kasachstan",
    msgKenya: "Kenia",
    msgKiribati: "Kiribati",
    msgKuwait: "Kuwait",
    msgKyrgyzstan: "Kirgisistan",
    msgLaos: "Laos",
    msgLatvia: "Lettland",
    msgLebanon: "Libanon",
    msgLesotho: "Lesotho",
    msgLiberia: "Liberia",
    msgLibyanJamahiriya: "Libysche Arabische Dschamahirija",
    msgLiechtenstein: "Liechtenstein",
    msgLithuania: "Litauen",
    msgLuxembourg: "Luxemburg",
    msgMacao: "Macao",
    msgNorthMacedonia: "Nordmazedonien",
    msgMadagascar: "Madagaskar",
    msgMalawi: "Malawi",
    msgMalaysia: "Malaysia",
    msgMaldives: "Malediven",
    msgMali: "Mali",
    msgMalta: "Malta",
    msgMarshallIslands: "Marshallinseln",
    msgMartinique: "Martinique",
    msgMauritania: "Mauretanien",
    msgMauritius: "Mauritius",
    msgMayotte: "Mayotte",
    msgMexico: "Mexiko",
    msgMicronesia: "Mikronesien, Föderierte Staaten von",
    msgMoldova: "Moldawien",
    msgMonaco: "Monaco",
    msgMongolia: "Mongolei",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Montenegro",
    msgMorocco: "Marokko",
    msgMozambique: "Mosambik",
    msgMyanmar: "Myanmar",
    msgNamibia: "Namibia",
    msgNauru: "Nauru",
    msgNepal: "Nepal",
    msgNetherlands: "Niederlande",
    msgNetherlandsAntilles: "Niederländische Antillen",
    msgNewCaledonia: "Neukaledonien",
    msgNewZealand: "Neuseeland",
    msgNicaragua: "Nicaragua",
    msgNiger: "Niger",
    msgNigeria: "Nigeria",
    msgNiue: "Niue",
    msgNorfolkIsland: "Norfolkinsel",
    msgNorthKorea: "Nordkorea",
    msgNorthernIreland: "Nordirland",
    msgNorthernMariana: "Nördliche Marianen",
    msgNorway: "Norwegen",
    msgOman: "Oman",
    msgPakistan: "Pakistan",
    msgPalau: "Palau",
    msgPalestine: "Palästina",
    msgPanama: "Panama",
    msgPapua: "Papua-Neuguinea",
    msgParaguay: "Paraguay",
    msgPeru: "Peru",
    msgPhilippines: "Philippinen",
    msgPitcairn: "Pitcairninseln",
    msgPoland: "Polen",
    msgPortugal: "Portugal",
    msgPuertoRico: "Puerto Rico",
    msgQatar: "Katar",
    msgReunion: "Réunion",
    msgRomania: "Rumänien",
    msgRussianFederation: "Russische Föderation",
    msgRwanda: "Ruanda",
    msgSaintHelena: "Sankt Helena",
    msgSaintKitts: "Saint Kitts und Nevis",
    msgSaintLucia: "Saint Lucia",
    msgSaintPierre: "Saint-Pierre und Miquelon",
    msgSaintVincent: "Saint Vincent und die Grenadinen",
    msgSamoa: "Samoa",
    msgSanMarino: "San Marino",
    msgSaoTome: "São Tomé und Príncipe",
    msgSaudiArabia: "Saudi-Arabien",
    msgScotland: "Schottland",
    msgSenegal: "Senegal",
    msgSerbia: "Serbien",
    msgSeychelles: "Seychellen",
    msgSierraLeone: "Sierra Leone",
    msgSingapore: "Singapur",
    msgSlovakia: "Slowakei",
    msgSlovenia: "Slowenien",
    msgSolomonIslands: "Salomonen",
    msgSomalia: "Somalia",
    msgSouthAfrica: "Südafrika",
    msgSouthSandwich: "Südgeorgien und die Südlichen Sandwichinseln",
    msgSouthKorea: "Südkorea",
    msgSouthSudan: "Südsudan",
    msgSpain: "Spanien",
    msgSriLanka: "Sri Lanka",
    msgSudan: "Sudan",
    msgSuriname: "Surinam",
    msgSvalbardJan: "Svalbard und Jan Mayen",
    msgSwaziland: "Eswatini",
    msgSweden: "Schweden",
    msgSwitzerland: "Schweiz",
    msgSyria: "Syrien",
    msgTajikistan: "Tadschikistan",
    msgTanzania: "Tansania",
    msgThailand: "Thailand",
    msgTimorLeste: "Osttimor",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trinidad und Tobago",
    msgTunisia: "Tunesien",
    msgTurkey: "Türkei",
    msgTurkmenistan: "Turkmenistan",
    msgTurksCaicos: "Turks- und Caicosinseln",
    msgTuvalu: "Tuvalu",
    msgUganda: "Uganda",
    msgUkraine: "Ukraine",
    msgUnitedArabEmirates: "Vereinigte Arabische Emirate",
    msgUnitedKingdom: "Vereinigtes Königreich",
    msgUnitedStates: "Vereinigte Staaten",
    msgUnitedStatesMinor: "Vereinigte Staaten, unincorporated Gebirgsländer",
    msgUruguay: "Uruguay",
    msgUzbekistan: "Usbekistan",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Venezuela",
    msgVietnam: "Vietnam",
    msgVirginIslandsBritish: "Britische Jungferninseln",
    msgVirginIslandsUS: "Jungferninseln der USA",
    msgWales: "Wales",
    msgWallisFutuna: "Wallis und Futuna",
    msgWesternSahara: "Westsahara",
    msgYemen: "Jemen",
    msgZambia: "Sambia",
    msgZimbabwe: "Simbabwe",
}
export default de;